import { useSelector } from "react-redux";

export function useRoleChecker() {
  const { access = [] } = useSelector(({ auth }) => ({
    access: auth.user.access_role.access
  }));

  return (action, subject) => {
    if (!(access instanceof Array)) {
      return false;
    }

    return access.some(acc => {
      if (acc.action === "manage") {
        return acc.subject === subject || acc.subject === "all";
      }

      if (acc.subject === "all") {
        return acc.action === action || acc.action === "manage";
      }

      return acc.action === action && acc.subject === subject;
    });
  };
}
